var exports = {
  "ui": "Surface__2GcJIy",
  "UC": "Content__03npWi",
  "DZ": "Heading__SxIsmT",
  "hE": "Title__N5NSdF",
  "JU": "Label__qLTG3w",
  "VY": "Description__1NCKP-",
  "Kn": "ActionGroup__ic1iLd",
};

module.exports = exports;
